import isUUID from 'validator/es/lib/isUUID';

export function isValidUUID(value: string | null | undefined): value is string {
	if (!value) {
		return false;
	}

	return isUUID(value);
}
